<template>
    <div class="wizard-forms vrm-dess-wizard__grid">
        <div class="row ">
            <div class="col-md-10 col-md-offset-1">
                <h2>
                    {{
                        $t('firmware-library.releaseInfoHeader', {
                            i18nFallback: 'Release info',
                        })
                    }}
                </h2>
                <p>
                    {{
                        $t('firmware-library.releaseInfoDescription', {
                            i18nFallback:
                                'Every release will have a unique ID and title to help users quickly scan and differentiate between the releases you publish. The release ID is generated automatically once the release is finalized.',
                        })
                    }}
                </p>
                <br />

                <div class="row">
                    <div class="col-xs-12 col-sm-6 p-l-0">
                        <vrm-text-field
                            v-model="title"
                            :show-optional="true"
                            :title="
                                $t('firmware-library.title', {
                                    i18nFallback: 'Title',
                                })
                            "
                        ></vrm-text-field>
                    </div>
                </div>

                <div class="row">
                    <div class="col-xs-12 col-sm-6 p-l-0">
                        <vrm-text-area
                            v-model="changelog"
                            :show-optional="true"
                            :title="
                                $t('firmware-library.releaseNotes', {
                                    i18nFallback: 'Release notes',
                                })
                            "
                        ></vrm-text-area>
                    </div>
                </div>

                <br />
            </div>
        </div>
    </div>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import VrmTextArea from '@/vue/components/forms/VrmTextArea.vue';
import {
    CREATE_NEW_RELEASE_FORM_FIELDS,
    NEW_RELEASE,
} from '@/vue/store/modules/create-new-release-form';
import VrmTextField from '@/vue/components/forms/VrmTextField.vue';

@Component({
    components: { VrmTextField, VrmTextArea },
})
export default class Info extends Vue {
    @Prop()
    initialValues;

    creating = false;
    error = null;
    created() {
        this.creating = !this.changelog && !this.title;
    }

    compareAndEmitEdit(field, newValue) {
        let hasChange = this.initialValues[field] !== newValue;
        if (this.creating) {
            this.$emit('creating', true);
        }
        this.$emit('change', {
            hasChange: hasChange,
            formName: 'properties',
        });
    }

    get changelog() {
        return this.$store.state.createNewReleaseForm.changelog;
    }

    set changelog(value) {
        this.compareAndEmitEdit('changelog', value);
        this.$store.commit(NEW_RELEASE.SET_FORM_FIELD, {
            value: value,
            key: CREATE_NEW_RELEASE_FORM_FIELDS.changelog,
        });
    }

    get title() {
        return this.$store.state.createNewReleaseForm.title;
    }

    set title(value) {
        this.compareAndEmitEdit('title', value);
        this.$store.commit(NEW_RELEASE.SET_FORM_FIELD, {
            value: value,
            key: CREATE_NEW_RELEASE_FORM_FIELDS.title,
        });
    }
}
</script>
